import { useEffect, useRef } from 'react';

const Iframe = ({ children }) => {
  const iframeRef = useRef<HTMLIFrameElement>();

  useEffect(() => {
    if (iframeRef?.current) {
      iframeRef.current.style.height = `${iframeRef.current.contentWindow?.document?.body?.scrollHeight}px`;
    }
  }, [
    iframeRef,
    iframeRef.current?.contentWindow?.document?.body?.scrollHeight
  ]);

  return (
    <iframe
      name="contents"
      ref={iframeRef}
      title="content"
      srcDoc={`
                  <html>
                      <head>
                          <link
                              rel="stylesheet"
                              type="text/css"
                              href="https://blog.api.cloudez.io/wp-content/themes/twentytwentyone/style.css"
                          />
                          <link rel="preconnect" href="https://fonts.gstatic.com" />
                          <link
                              href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;700&family=Source+Sans+Pro:wght@300;400;600;700&display=swap"
                              rel="stylesheet"
                          />
                          <style>
                              body > * {
                                  font-family: Montserrat;
                              }
                              
                              body {
                                  background: white; 
                                  padding: 20px 30px;
                                  white-space: pre-wrap;
                                  overflow-wrap: break-word;
                                  line-height: 0.4;
  
                                  overflow: hidden;
                              }
  
                              body p,
                              body ul,
                              body ol,
                              body span,
                              body figure {
                                  font-family: Montserrat;
                                  line-height: 1.5em;
                                  margin: 0;
                                  font-size: 16px;
                              }
  
                              body h1,
                              body h3,
                              body h4,
                              body h5,
                              body h6 {
                                  margin-top: 20px;
                                  font-weight: bold;
                                  font-size: 19px;
                              }
  
                              body h2 {
                                  margin-top: 20px;
                                  font-weight: bold;
                                  font-size: 2rem;
                              }
  
                              body img {
                                  display: unset;
                                  max-width: 100%;
                                  height: auto;
                              }
  
                              body figcaption {
                                  font-size: 13px;
                              } 
  
  
                              .wp-block-columns {
                                  display: flex;
                                  margin: 20px 0;
                              }
  
                              .wp-block-column {
                                  flex: 1;
                                  margin: 0 20px;
                              }
  
                              @media (max-width: 764px) {
                                  .wp-block-columns {
                                      flex-flow: row wrap;
                                  }
  
                                  .wp-block-column:first-child {
                                      flex-basis: 100%;
                                  }
                              }
  
                              @media (max-width: 478px) {
                                  .wp-block-columns {
                                      display: block;
                                  }
  
                                  .wp-block-column {
                                      margin: 20px 0;
                                  }
                              }
                          </style>
                      </head>
                      <body>
                          ${children}
                      </body>
                  </html>
              `}
    />
  );
};
export default Iframe;
